
import './SeasonPane.scss';
export default function SeasonPane(props: {
    active: boolean,
    children: any,
    seriesTitle: string
}) {
    return (
        <div data-uia="season-pane" className={`${!props.active ? 'ltr-t51pl5' : 'ltr-1xeijo'} `}>
            <div className="ltr-nyg1rf">
                <h3 className="ltr-r7qpj1" data-uia="season-pane-title">{props.seriesTitle}</h3>
            </div>
            <div className="ltr-1d8v4z0">
                {props.children}
            </div>
        </div>
    );
}

export function SeasonPaneItem(props: {
    title: string,
    active: boolean,
    onClick: () => void
}) {
    return (
        <div className="ltr-1bv72uk" data-uia="season-pane-item-80114789" onClick={() => {
            if (props.onClick) {
                props.onClick();
            }
        }}>
            <div aria-label={props.title} tabIndex={0} className="ltr-2t1w26">
            </div>
            <div className={`ltr-zuse0i ${props.active ? 'active' : ''}`}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="Hawkins-Icon Hawkins-Icon-Standard">
                    <path fillRule="evenodd" clipRule="evenodd" d="M8.68239 19.7312L23.6824 5.73115L22.3178 4.26904L8.02404 17.6098L2.70718 12.293L1.29297 13.7072L7.29297 19.7072C7.67401 20.0882 8.28845 20.0988 8.68239 19.7312Z" fill="currentColor">
                    </path>
                </svg>
            </div>
            <span className="ltr-y8jwxx">{props.title}</span>
            <div data-show-on-hover="true" className="ltr-ydzts9">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="Hawkins-Icon Hawkins-Icon-Standard">
                    <path fillRule="evenodd" clipRule="evenodd" d="M0 11.0001L20.5858 11.0001L15.2929 5.70718L16.7071 4.29297L23.7071 11.293C23.8946 11.4805 24 11.7349 24 12.0001C24 12.2653 23.8946 12.5196 23.7071 12.7072L16.7071 19.7072L15.2929 18.293L20.5858 13.0001H0V11.0001Z" fill="currentColor">
                    </path>
                </svg>
            </div>
        </div>
    )
}